/**
 * A per-genie web app manifest, so a phone visitor can pin a genie's own page
 * to their home screen under the genie's name and logo. Built in the browser
 * and served as a Blob URL — icon and start URLs are absolute because nothing
 * resolves relative to a blob: base.
 */

export const GENIE_MANIFEST_FALLBACK_ICON = "/help-genie-mark.png";

export interface GenieManifestInput {
  name: string;
  urlName: string;
  origin: string;
  themeColor: string;
  logoUrl?: string | null;
}

export const genieHomeScreenIcon = (origin: string, logoUrl?: string | null) => {
  try {
    return new URL(logoUrl || GENIE_MANIFEST_FALLBACK_ICON, origin).href;
  } catch {
    // A malformed logo URL must not take the genie page down with it.
    return new URL(GENIE_MANIFEST_FALLBACK_ICON, origin).href;
  }
};

export const buildGenieManifest = ({ name, urlName, origin, themeColor, logoUrl }: GenieManifestInput) => {
  const startUrl = `${origin}/live-agent/${encodeURIComponent(urlName)}`;
  return {
    // One installable app per genie, not one per helpgenie.ai.
    id: startUrl,
    name,
    short_name: name,
    start_url: startUrl,
    scope: startUrl,
    display: "standalone",
    theme_color: themeColor,
    background_color: "#FFFFFF",
    icons: [{ src: genieHomeScreenIcon(origin, logoUrl), sizes: "any", purpose: "any" }],
  };
};
